import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { IRootState } from '../../app/app.config';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { setLoadingState } from '../app-configuration/app-configuration.actions';
import { catchError, finalize } from 'rxjs';
import { logout } from '../auth/authentication.actions';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const store$ = inject(Store<IRootState>);
  const skipLoading = req.headers.get('skip-loading');
  if (!skipLoading) {
    store$.dispatch(setLoadingState({ isLoading: true }));
  }

  const handleError = (error: HttpErrorResponse) => {
    if (error.status === 401) {
      store$.dispatch(logout());
    }
    throw error; // Rethrow the error
  };

  
  return next(req).pipe(
    finalize(() => {
      store$.dispatch(setLoadingState({ isLoading: false }));
    }),
    catchError((error: HttpErrorResponse) => handleError(error))
  );
};
